import { styled, Typography } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const FormLabelDescription = styled(Typography, { shouldForwardProp: prop => prop !== 'disabled' })(({ disabled, theme }) => ({
  marginBottom: theme.spacing(1),
  ...(disabled && {
    color: theme.palette.text.disabled,
  }),
  '& > p': {
    marginTop: 0,
    marginBottom: theme.spacing(1),
  },
}));
